import { create } from 'zustand';

type LogisticsFields = {
  name: string;
  email: string;
  position: string;
  extension: number | '';
  cellPhone: string;
  disclaimer: string;
  linkedin: string;
  updatesEmail: string;
  hasLoadbaseBanner: boolean;
  hasWarehouse411Banner: boolean;
  hasSocials: boolean;
  pictureUrl?: string;
};

type LogisticsStore = LogisticsFields & {
  setField: <K extends keyof LogisticsFields>(key: K, value: LogisticsFields[K]) => void;
};

export const useLogisticsStore = create<LogisticsStore>((set) => ({
  name: 'John Doe',
  email: 'john.doe@shipsierra.com',
  position: 'Dispatch',
  extension: 101,
  cellPhone: '(916) 123-4567',
  linkedin: '',
  disclaimer: 'Sierra Logistics Solutions DBA shipsierra.com emails and domains end with (@shipsierra.com). Any other emails you may have been communicated through should' +
    ' be deleted and' +
    ' reported. The content of this email is confidential and intended for the recipient specified in message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.',
  updatesEmail: 'tracking@shipsierra.com',
  hasLoadbaseBanner: true,
  hasWarehouse411Banner: true,
  hasSocials: false,
  pictureUrl: '',

  setField: (key, value) => set((state) => ({ ...state, [key]: value })),
}));